import React from "react";
import { all_routes } from "../../../../Router/all_routes";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import TextEditor from "../../../inventory/texteditor";
import { DatePicker } from "antd";

const AddJob = () => {
  const route = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Create Opening
                  </h4>
                </ol>
              </nav>
              <h6>Create new Job Opening here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <RefreshIcon />
            <CollapesIcon />
            <li>
              <div className="page-btn">
                <Link
                  to={route.applicanttrackingjobsPosting}
                  className="btn btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back to Jobs
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-body p-4">
            <form className="add-product-form ">
              <div className="add-product">
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Company<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Title<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={warehouse}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="summer-description-box">
                      <label className="form-label">Job Description</label>
                      <TextEditor />
                      <p className="fs-14 mt-1">Maximum 60 Words</p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="summer-description-box">
                      <label className="form-label">Job Requirement</label>
                      <TextEditor />
                      <p className="fs-14 mt-1">Maximum 60 Words</p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Locations<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Categories
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Skills<span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Total Positions
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control list" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        End Date<span className="text-danger ms-1">*</span>
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Type
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Work Experience
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Show Pay By
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Starting salary
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control list" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Maximum salary
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input type="text" className="form-control list" />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Rate
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Meta Title
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        // options={store}
                        placeholder="Choose"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Meta Description
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <textarea
                        className="form-control list"
                        // options={store}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      Ask applicants for
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                      <div className=" d-flex align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="warranties"
                            defaultValue="option1"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="warranties"
                          >
                            Gender
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="manufacturer"
                            defaultValue="option2"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="manufacturer"
                          >
                            Date of Birth(Required)
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Country
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Address
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      Section Visibility
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                      <div className=" d-flex align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="warranties"
                            defaultValue="option1"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="warranties"
                          >
                            Profile Image
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="manufacturer"
                            defaultValue="option2"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="manufacturer"
                          >
                            Resume
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Cover letter
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Terms & Conditions
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="d-flex align-items-center justify-content-end mb-4">
            <button type="button" className="btn btn-secondary me-2">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Add Opening
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddJob;
